import slugid from "slugid";
import { IOrganization, Organization } from "../models/organization";
import { IStore, Store } from "../models/store";
import { ICabinet, Cabinet } from "../models/cabinet";

export const getSlugId = (): string => {
  return slugid.nice();
};

export const encodeBase64 = (data: string): string => {
  const buff = Buffer.from(data, "ascii");
  return buff.toString("base64");
};

export const generateOrganizationFromConfig = (args: IOrganization) => {
  return Organization.create(args);
};

export const generateOrganizationsFromConfigArray = (args: IOrganization[]) => {
  const orgList = [];
  for (let i = 0; i < args.length; i++) {
    orgList.push(Organization.create(args[i]));
  }
  return orgList;
};

export const generateStoreFromConfig = (args: IStore) => {
  return Store.create(args);
};

export const generateStoresFromConfigArray = (args: IStore[]) => {
  const storeList = [];
  for (let i = 0; i < args.length; i++) {
    storeList.push(generateStoreFromConfig(args[i]));
  }
  return storeList;
};

export const generateCabinetFromConfig = (args: ICabinet) => {
  return Cabinet.create(args);
};

export const generateCabinetsFromConfigArray = (args: ICabinet[]) => {
  const cabinetList = [];
  for (let i = 0; i < args.length; i++) {
    cabinetList.push(generateCabinetFromConfig(args[i]));
  }
  return cabinetList;
};
